import { handleSetLoading, handleSetToken, handleUpdatePartially } from './middleware';

export enum CustomerAccess {
	BASIC = 'SIMULATED_BASIC',
	ACTION = 'SIMULATED_ACTION',
}

export enum CustomerRole {
	SUPERVISOR = 'SUPERVISOR',
	CONSULTANT = 'CONSULTANT',
}

export type CustomerRestrictionTypes = 'QUOTATION' | 'SIMULATED' | 'NO_LINKS' | '2FA_EXPIRED' | 'PARTNER';

export type AccessType = CustomerAccess.BASIC | CustomerAccess.ACTION;
export type HyperaRole = CustomerRole.SUPERVISOR | CustomerRole.CONSULTANT;

export interface CustomerParams {
	id: string;
	name: string;
	email: string;
	cpf: string;
	phones: string[];
	enabled: boolean;
	contactPreferences: string[];
	accessType: AccessType | null;
	hyperaRole: HyperaRole | null;
	serasaScore: number | null;
	serasaBlockedUntil: string | null;
	hyperaRegistration: string | null;
	sectorId: number | null;
	phoneNumber: string | null;
	phoneNumberConfirmed: boolean;
	twoFAExpiration?: number;
}

export type CustomerProvider = 'PARCEIRO_HYPERA' | string;

export interface CustomerReducer {
	loading: boolean;
	data: CustomerParams;
	token: string | null;
	userIsLoggingOut: boolean;
	provider: CustomerProvider | null;
	partnerLabel: string | null;
	firstAccess: string[];
	firstAccessCurrentStep: number;
	deviceToken?: string;
}

export interface HandleGetCustomerDataParams {
	ignoreLoading?: boolean;
}

export interface HandleGetCustomerDataReturn {
	payload: {
		customer: CustomerReducer['data'];
	};
}

export type HandleGetCustomerDataType = (options?: HandleGetCustomerDataParams) => Promise<HandleGetCustomerDataReturn>;

export type PermissionIds =
	| 'BASKET_EDIT'
	| 'DISTRIBUTOR_EDIT'
	| 'BASKET_FINALIZE'
	| 'USER_DATA_EDIT'
	| 'ACCESS_MANAGE_EDIT'
	| 'LIST_POS';

export interface PermissionGateProps {
	children: JSX.Element;
	id: PermissionIds;
}

export type HandleSetLoadingType = typeof handleSetLoading;
export type HandleUpdatePartiallyType = typeof handleUpdatePartially;
export type HandleSetTokenType = typeof handleSetToken;
